import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';

import { FeatureCtaContainer } from 'containers/common/app/feature-cta-container';
import { FaqContainer } from 'containers/common/components/faq/faq-container';
import { ComplimentsBlockFourContainer } from 'containers/features/compliments/compliments-block-four-container';
import { ComplimentsBlockOneContainer } from 'containers/features/compliments/compliments-block-one-container';
import { ComplimentsBlockThreeContainer } from 'containers/features/compliments/compliments-block-three-container';
import { ComplimentsBlockTwoContainer } from 'containers/features/compliments/compliments-block-two-container';
import { ComplimentsHeroBlockContainer } from 'containers/features/compliments/compliments-hero-block-container';
import { PageContainer } from 'containers/page/page-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

const faqContent = () => [
  {
    question: features.compliments.lxComplimentsFaqQuestionOneTitle,
    answer: features.compliments.lxComplimentsFaqQuestionOneAnswer,
  },
  {
    question: features.compliments.lxComplimentsFaqQuestionTwoTitle,
    answer: features.compliments.lxComplimentsFaqQuestionTwoAnswer,
  },
  {
    question: features.compliments.lxComplimentsFaqQuestionThreeTitle,
    answer: features.compliments.lxComplimentsFaqQuestionThreeAnswer,
  },
];

export const ComplimentsContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <ComplimentsHeroBlockContainer />
        <ComplimentsBlockOneContainer />
        <ComplimentsBlockTwoContainer />
        <ComplimentsBlockThreeContainer />
        <ComplimentsBlockFourContainer />
        <FaqContainer title={features.compliments.lxFeaturesFaqTitle} content={faqContent()} />
        <FeatureCtaContainer title={features.compliments.lxComplimentsCta} />
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
